import { useCaseDeleteCase } from 'api/case/case';
import { CaseModel } from 'api/model';
import ConfirmModal from 'components/Modal/ConfirmModal';
import LoadingSpinner from 'components/spinners/LoadingSpinner';
import Routes from 'constants/Routes';
import React from 'react';
import { showException } from 'utils/exception-helper';

interface Props {
  caseModel: CaseModel;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmDeleteCaseModal: React.FC<Props> = ({
  caseModel,

  onCancel,
  onConfirm,
}) => {
  const deleteCase = useCaseDeleteCase();

  const handleConfirm = async () => {
    try {
      await deleteCase.mutateAsync({
        params: {
          caseId: caseModel.caseID,
        },
      });
      // if we are currently on the case page or the case id, navigate up one level
      if (
        window.location.pathname ===
        `${Routes.placeholder.index}/${caseModel.caseID.toString()}`
      ) {
        window.location.href = Routes.placeholder.index;
      } else if (
        window.location.pathname ===
        `${Routes.search.index}/${caseModel.caseID.toString()}`
      ) {
        window.location.href = Routes.search.index;
      }
      onConfirm();
    } catch (error) {
      showException(error);
    }
  };

  return (
    <ConfirmModal
      title="Ta bort utfyllnadsuppdrag"
      content="Är du säker på att du vill ta bort utfyllnadsuppdraget?"
      onConfirm={handleConfirm}
      onCancel={onCancel}
      disabled={deleteCase.isLoading}
    >
      {deleteCase.isLoading && (
        <LoadingSpinner>Tar bort utfyllnadsuppdrag...</LoadingSpinner>
      )}
    </ConfirmModal>
  );
};

export default ConfirmDeleteCaseModal;
